import { render } from "./InfoBar.vue?vue&type=template&id=1946f055&scoped=true"
import script from "./InfoBar.vue?vue&type=script&lang=js"
export * from "./InfoBar.vue?vue&type=script&lang=js"

import "./InfoBar.vue?vue&type=style&index=0&id=1946f055&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1946f055"]])

export default __exports__